<template>
  <section class="reference-section">
    <div
        class="reference-section__header"
        role="button"
        tabindex="0"
        @click="$emit('toggle')"
        @keydown.enter.prevent="$emit('toggle')"
        @keydown.space.prevent="$emit('toggle')"
    >
      <div class="reference-section__title-wrap">
        <div class="reference-section__title-line"></div>

        <div class="reference-section__title">
          {{ title }}
        </div>
      </div>

      <DownOutlined
          data-html2canvas-ignore
          class="reference-section__icon"
          :class="{ 'reference-section__icon_open': opened }"
      />
    </div>

    <Transition name="reference-section-slide">
      <div v-show="opened" class="reference-section__body">
        <slot />
      </div>
    </Transition>
  </section>
</template>

<script>
import { DownOutlined } from "@ant-design/icons-vue";

export default {
  name: "ReferenceSection",

  components: {
    DownOutlined,
  },

  props: {
    title: {
      type: String,
      required: true,
    },

    opened: {
      type: Boolean,
      default: true,
    },
  },

  emits: ["toggle"],
};
</script>

<style lang="scss" scoped>
.reference-section:not(:last-child) {
  width: 100%;
  margin-bottom: 32px;
}

.reference-section__header {
  width: 100%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 16px;
  cursor: pointer;
  text-align: left;
}

.reference-section__title-wrap {
  display: flex;
  align-items: center;
  column-gap: 16px;
}

.reference-section__title {
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.85);
}

.reference-section__title-line {
  flex-shrink: 0;
  width: 4px;
  height: 26px;
  border-radius: 6px;
  background: #21ac0c;
}

.reference-section__icon {
  flex-shrink: 0;
  font-size: 16px;
  color: #1f1f1f;
  transition: transform 0.22s ease;
}

.reference-section__icon_open {
  transform: rotate(180deg);
}

.reference-section__body {
  margin-top: 20px;
  overflow: hidden;
}

.reference-section-slide-enter-active,
.reference-section-slide-leave-active {
  transition:
      opacity 0.22s ease,
      transform 0.22s ease,
      max-height 0.24s ease;
  max-height: 600px;
}

.reference-section-slide-enter-from,
.reference-section-slide-leave-to {
  opacity: 0;
  transform: translateY(-6px);
  max-height: 0;
}

.reference-section-slide-enter-to,
.reference-section-slide-leave-from {
  opacity: 1;
  transform: translateY(0);
  max-height: 600px;
}
</style>
